import * as React from 'react'

function SvgQuestionMark(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox='0 0 17 19' {...props}>
			<path
				fill="currentColor"
				d="M10.55 8.297c-.68.66-1.106 1.203-1.106 2.56H7.556v-.452c0-.995.425-1.9 1.105-2.56l1.17-1.14c.35-.326.558-.779.558-1.276 0-.996-.85-1.81-1.889-1.81-1.039 0-1.889.814-1.889 1.81H4.722c0-2 1.69-3.62 3.778-3.62 2.087 0 3.778 1.62 3.778 3.62 0 .796-.34 1.52-.879 2.035zm-2.994 4.37h1.878v1.81H7.556zM1.889 0C.84 0 0 .814 0 1.81v12.666c0 .995.84 1.81 1.889 1.81h3.778L8.5 19l2.833-2.714h3.778c1.039 0 1.889-.815 1.889-1.81V1.81C17 .814 16.15 0 15.111 0z"
			/>
		</svg>
	)
}

export default SvgQuestionMark
